/** 阅读一本书：EPUB / PDF 按原版，Markdown 与网页按文字。可以从出处带着引文跳来（start/end/q）。 */
import { createFileRoute } from "@tanstack/react-router";
import { Reader } from "@/features/reader/Reader";
import { errorMessage } from "@/shared/api/client";
import { useSource } from "@/shared/api/hooks";
import { Empty, ErrorNote, Spinner } from "@/shared/ui";

type Search = { start?: number; end?: number; q?: string; ann?: string };

export const Route = createFileRoute("/read/$sourceId")({
  validateSearch: (s: Record<string, unknown>): Search => ({
    start: typeof s.start === "number" ? s.start : undefined,
    end: typeof s.end === "number" ? s.end : undefined,
    q: typeof s.q === "string" ? s.q : undefined,
    ann: typeof s.ann === "string" ? s.ann : undefined,
  }),
  component: ReadPage,
});

function ReadPage() {
  const { sourceId } = Route.useParams();
  const jump = Route.useSearch();
  const source = useSource(sourceId);
  if (source.isPending)
    return (
      <div className="grid h-full place-items-center text-text-3">
        <Spinner />
      </div>
    );
  if (source.error)
    return (
      <div className="p-6">
        <ErrorNote>{errorMessage(source.error)}</ErrorNote>
      </div>
    );
  if (!source.data.view)
    return (
      <div className="p-6">
        <Empty title="这份资料还不能读">正在解析，或者没有读到正文。</Empty>
      </div>
    );
  return <Reader key={sourceId} source={source.data} jump={jump} />;
}
